import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/global-assets/4.0.1/legacy/0/images/logo_immowelt.svg'
import _imports_1 from '../assets/global-assets/4.0.1/legacy/0/images/logo_immowelt_blank.svg'


const _withScopeId = n => (_pushScopeId("data-v-5acd50c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0
const _hoisted_2 = _imports_1
const _hoisted_3 = { class: "signin-formOuterWrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", null, [
  /*#__PURE__*/_createElementVNode("source", {
    media: "(min-width: 981px)",
    srcset: _hoisted_1,
    alt: "Immobilien, Wohnungen und Häuser",
    title: "Immobilien, Wohnungen und Häuser"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    media: "(max-width: 980px)",
    srcset: _hoisted_2,
    alt: "Immobilien, Wohnungen und Häuser",
    title: "Immobilien, Wohnungen und Häuser"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Immobilien, Wohnungen und Häuser",
    title: "Immobilien, Wohnungen und Häuser"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "signin-formInnerWrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Freischaltung per SMS", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "mtan-login-hint-box",
  class: "signin-mtan"
}, " Wir haben Ihnen eine 6-stellige mTAN auf ihr Handy ( ********** ) gesendet. Bitte geben Sie diese mTAN in das folgende Eingabefeld ein, um sich einzuloggen. ", -1))
const _hoisted_9 = {
  key: 0,
  class: "messagebox messagebox--error"
}
const _hoisted_10 = { class: "inputfield" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Freischaltungscode eingeben: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin-additional-login-fields" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "trust-browser-inputfield" }, [
    /*#__PURE__*/_createTextVNode(" Diesem Browser dauerhaft vertrauen: "),
    /*#__PURE__*/_createElementVNode("input", {
      id: "trustBrowserInput",
      class: "signin-trust-browser trust-browser-input",
      type: "checkbox",
      name: "rememberMe"
    })
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("input", {
    id: "signin-button",
    class: "signin-button signin-button--primary signin-button--big",
    type: "submit",
    value: "Abschicken",
    tabindex: "3"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "signin-formInnerWrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message_info" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Keine SMS erhalten?"),
    /*#__PURE__*/_createElementVNode("p", null, " Sie haben unsere SMS innerhalb von 5 Minuten nicht erhalten? Lassen Sie sich eine neue mTAN senden oder kontaktieren Sie den Support der Immowelt AG. "),
    /*#__PURE__*/_createElementVNode("input", {
      id: "challengeRecreateButton",
      type: "submit",
      class: "btn_02 black btn_small",
      value: "Eine neue mTAN senden"
    })
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          href: "//www.immowelt.de",
          title: "Immowelt",
          class: "signin-logoWrap"
        }, _hoisted_5),
        _createElementVNode("form", {
          id: "loginForm",
          action: "https://signin.immowelt.de/?target=meinbereich&path=%2Fredirect",
          method: "post",
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            (_ctx.formErrors.code.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.formErrors.code), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  id: "challengeInput",
                  type: "text",
                  tabindex: "1",
                  name: "challengeInput",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.codice) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.codice]
                ])
              ]),
              _hoisted_12,
              _hoisted_13
            ])
          ])
        ], 32),
        _createElementVNode("form", {
          class: "challenge-recreate-form",
          id: "challengeRecreateForm",
          action: "/register?target=meinbereich&path=%2Fredirect",
          method: "post",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startOver && _ctx.startOver(...args)), ["prevent"]))
        }, _hoisted_15, 32)
      ])
    ]),
    _: 1
  }))
}